// extracted by mini-css-extract-plugin
export var buttons = "_b0-0";
export var buttonsActive = "_b0-h";
export var cancelConfirm = "_b0-1";
export var closeButton = "_b0-2";
export var column = "_b0-3";
export var container = "_b0-4";
export var detailHeader = "_b0-6";
export var detailTitle = "_b0-7";
export var detailsContent = "_b0-5";
export var header = "_b0-8";
export var headerWithClose = "_b0-9";
export var icon = "_b0-a";
export var infoIcon = "_b0-c";
export var informationContainer = "_b0-b";
export var sideDrawer = "_b0-d";
export var sideDrawerOpen = "_b0-e";
export var stickyFooter = "_b0-f";
export var typeOption = "_b0-g";